module.exports = __webpack_public_path__ + "media/images/flags/1x1/gib-c3cb719e8da50ccc9d88b90b6dd2643a.svg";